import React, { useEffect, useState } from "react";
import { Flex, notification, InputNumber, Select } from "antd";

import { Link, useLocation, useNavigate } from "react-router-dom"
import {

    ArrowLeftOutlined,
  } from "@ant-design/icons";
import { ASSETS_BASE_URL } from "../../../config/constants";


const ProductDetails = () => {
  const { Option } = Select;
  const location = useLocation();
  const state = location.state.items;
  const [productData,setOrderData]=useState(state??[])
  const navigate = useNavigate();


  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div>
        <div className="orders_main_contaniner">
  <div>
    <nav className="navbar navbar-light justify-content-between w-100 navbar_content">
      <Link to="/order/list" className="navbar-brand common_inventory_heading">
        Product Details
      </Link>
      <Link to={"/product/list"}>
        <React.Fragment>
          <button type="button" className="btn btn-secondary">
            <ArrowLeftOutlined /> Back
          </button>
        </React.Fragment>
      </Link>
    </nav>
  </div>

  <div className="order_now_card_title">
    <div className="card">
      <div className="card-body order_now_date_and_time_section">
        <span className="orders_now_billing_details_heading">
          Product Details
        </span>
      </div>
    </div>
  </div>

  <div className="row mt-4">
    <div className="col-lg-8">
      <div className="card mb-4">
        <div className="card-body">
          <div className="mb-3 d-flex justify-content-between">
            <div>
              <span className="orders_now_billing_details_heading">
                Product Information
              </span>
            </div>
          </div>
          <div className="product-details">
            <img
              src={`${ASSETS_BASE_URL}${productData?.image}`}
              alt={productData?.name}
              className="product-image"
            />
            <p><strong>Name:</strong> {productData?.name}</p>
            <p><strong>Description:</strong> {productData?.description}</p>
            <p><strong>Slug:</strong> {productData?.slug}</p>
            <p><strong>Status:</strong> {productData?.status}</p>
          </div>
        </div>
      </div>

      <div className="card mb-4">
        <div className="card-body">
          <span className="orders_now_billing_details_heading">
            Variant Details
          </span>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Variant ID</th>
                <th>Unit</th>
                <th>Available Qty</th>
                <th>Price</th>
                <th>Total Qty</th>
              </tr>
            </thead>
            <tbody>
              {productData?.variants?.length > 0 ? (
                productData.variants.map((variant, index) => (
                  <tr key={index}>
                    <td>{variant?._id || "N/A"}</td>
                    <td>{variant?.unit || "N/A"}</td>
                    <td>{variant?.avl_qty || "N/A"}</td>
                    <td>{variant?.price || "N/A"}</td>
                    <td>{variant?.qty || "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No variants available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div className="col-lg-4">
      {/* Additional sections like seller details can be added here */}
    </div>
  </div>
</div>

      </div>
      </div>
      {/* <LoadingEffect isLoading={isLoading} /> */}
    </div>
  );
};

export default ProductDetails;
